export const isDev = import.meta.env.DEV || import.meta.env.VITE_TEST;
